import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { PrimeiroCadastroDTO } from '../../models/cadastro/primeiro-cadastro.model';

@Injectable({
  providedIn: 'root',
})
export class PrimeiroCadastroService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  // Métodos da interface (se necessário)
  get<T>(url: string, data?: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  getById<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }
  post<T>(url: string, data: any): Observable<any> {
    return this.apiService.create(url, data);
  }
  put<T>(url: string, data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  delete<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  // Método para chamar o endpoint de cadastro
  // O backend retorna texto puro ("Usuário cadastrado com sucesso"), não JSON.
  // Por isso usamos postText() em vez de create(), evitando erro de JSON.parse().
  primeiroCadastro(data: PrimeiroCadastroDTO): Observable<string> {
    return this.apiService.postText('/configuracaoEmpresa/primeiro-cadastro', data);
  }
}
